import axios from "axios";
import CryptoJS from "crypto-js";
const { VUE_APP_SHIELD_URL, VUE_APP_SPONSOR, VUE_APP_CRYPTO, VUE_APP_FLOW_QA } =
  process.env;

function decryptFromURL(encryptedData) {
  const key = atob(VUE_APP_CRYPTO);
  const base64 =
    encryptedData.replace(/-/g, "+").replace(/_/g, "/") +
    "===".slice((encryptedData.length + 3) % 4);
  const bytes = CryptoJS.AES.decrypt(base64, key);
  const decryptedData = bytes.toString(CryptoJS.enc.Utf8);
  return decryptedData;
}

export default class ShieldService {
  static async newCreateStep(
    userData,
    benefData,
    planData,
    servicesData,
    step,
    tokenStep,
  ) {
    try {
      let url;
      const jsonData = {
        userData,
        benefData,
        planData,
        servicesData,
        step,
        sponsor: VUE_APP_SPONSOR,
      };

      if (servicesData.type == "create") {
        url = "/step/newCreate";
      } else if (servicesData.type == "update") {
        url = "/step/newUpdate";
      }
      const carroResponse = await axios.post(
        `${VUE_APP_SHIELD_URL}${url}`,
        jsonData,
        {
          headers: {
            // Se agrega el header de autorización
            "x-captcha-authorization": tokenStep,
          },
        },
      );

      return carroResponse;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error en el servicio Stepers",
      };
    }
  }

  static async newGetStepAbandoned(stepId) {
    const shieldRes = await axios.get(
      `${VUE_APP_SHIELD_URL}/step/newGetAbandoned/${stepId}`,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data;
    else throw shieldRes.data;
  }

  static async createContactActiveCampain(userData, servicesData) {
    try {
      const shieldRes = await axios.post(
        `${VUE_APP_SHIELD_URL}/activeCampain/createContact`,
        {
          userData,
          servicesData,
          sponsor: VUE_APP_SPONSOR,
        },
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al crear el contacto",
      };
    }
  }

  static async updateContactActiveCampain(
    userData,
    planData,
    servicesData,
    index,
  ) {
    try {
      const shieldRes = await axios.put(
        `${VUE_APP_SHIELD_URL}/activeCampain/updateContact`,
        {
          userData,
          planData,
          servicesData,
          index,
          sponsor: VUE_APP_SPONSOR,
        },
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async getContactActiveCampain(email) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/activeCampain/getContact/${email}`,
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async getPlans(age, type, code) {
    let cantBenf;
    let category;
    let maxAge = age;

    if (maxAge >= 18 && maxAge <= 54) {
      category = `IRAM01`;
      cantBenf = `Plan18-54 ${type}`;
    } else if (maxAge >= 55 && maxAge <= 64) {
      category = `IRAM02`;
      cantBenf = `Plan55-64 ${type}`;
    } else if (maxAge >= 65 && maxAge <= 78) {
      category = `IRAM03`;
      cantBenf = `Plan65-79 ${type}`;
    } else if (maxAge > 80) {
      category = `IRAM04`;
      cantBenf = `Plan80+ ${type}`;
    }

    try {
      let url = `${VUE_APP_SHIELD_URL}/oncologico`;
      let params = "";

      if (code) {
        params =
          url +
          `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&code=${code}&t=${Date.now()}`;
      } else {
        params =
          url +
          `?sponsor=${VUE_APP_SPONSOR}&category=${category}&cantBenf=${cantBenf}&age=${maxAge}&t=${Date.now()}`;
      }

      const shieldRes = await axios.get(params);

      const decrypted = decryptFromURL(shieldRes.data.data);
      let planssss = JSON.parse(decrypted);

      return shieldRes.data.status === "ok" ? planssss : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async getPeople(personID) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/person/get/${personID}`,
      );

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener los planes",
      };
    }
  }

  static async createInsurance(person, beneficiaries, plan, stepId) {
    let flow_qa = false;
    if (VUE_APP_FLOW_QA == "true") {
      flow_qa = true;
    }

    person.forecast = person.salud;
    person.birthdate = person.dates;

    //Generar Array ordenado de Beneficiarios
    let BenefData = [];

    if (person.typePlan == "Familiar") {
      beneficiaries.forEach((benef) => {
        BenefData.push({
          name: benef.name,
          surname: benef.surname,
          rut: benef.rut,
          parentesco: benef.tipo,
          fechaNacimiento:
            "" + benef.day.id + "-" + benef.month.number + "-" + benef.year.id,
        });
      });
    }

    person.BenefData = BenefData;

    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = {
      person,
      planId: plan._id,
      stepId: stepId,
      flow_qa: flow_qa,
    };

    const shieldRes = await axios.post(
      // `${VUE_APP_SHIELD_URL}/oncologico`,
      //aca hay que cambiar algo al parecer o al menos bipassear el proceso de insurance
      `${VUE_APP_SHIELD_URL}/oncologico/createWithRunWayPayment`,
      jsonData,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }

  static async createInsuranceWithToku(person, beneficiaries, plan, stepId) {
    person.forecast = person.salud;
    person.birthdate = person.dates;

    //Generar Array ordenado de Beneficiarios
    let BenefData = [];
    if (beneficiaries) {
      beneficiaries.forEach((benef) => {
        BenefData.push({
          name: benef.name,
          surname: benef.surname,
          rut: benef.rut,
          parentesco: benef.tipo,
          fechaNacimiento:
            "" + benef.day + "-" + benef.month + "-" + benef.year,
        });
      });
      person.BenefData = BenefData;
    }

    let sponsorTokuRedirect = process.env.VUE_APP_SPONSOR_TOKU_REDIRECT;

    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = {
      person,
      planId: plan[0]._id,
      stepId: stepId,
      sponsorTokuRedirect: sponsorTokuRedirect,
    };

    const shieldRes = await axios.post(
      `${VUE_APP_SHIELD_URL}/oncologico/createWithToku`,
      jsonData,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data;
    else throw shieldRes.data;
  }

  static async getMigrates(cotizacionId) {
    const cotizacionData = await axios.get(
      `${VUE_APP_SHIELD_URL}/oncologico/getMigrates/${cotizacionId}`,
    );
    if (cotizacionData.data.status === "ok") return cotizacionData.data.data;
    else throw cotizacionData.data;
  }

  static async updateMigrates(cotizacionId, plan) {
    //Se genera la petición a SIELD para generar la Insurance y conección a Instanda
    const jsonData = {
      cotizacionId: cotizacionId,
      planId: plan[0]._id,
    };

    const shieldRes = await axios.put(
      // `${VUE_APP_SHIELD_URL}/oncologico`,
      `${VUE_APP_SHIELD_URL}/oncologico/updateMigrates/${cotizacionId}`,
      jsonData,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }

  static async getUFPrice() {
    try {
      const shieldRes = await axios.get(`${VUE_APP_SHIELD_URL}/hogar/getUf`);

      return shieldRes.data.status === "ok" ? shieldRes.data.data : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener el valor de la UF",
      };
    }
  }
  static async consultRutBlacklist(rut, token) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/blackList/consultRut`,
        {
          params: {
            rut,
          },
          headers: {
            "x-captcha-authorization": token,
          },
        },
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la lista negra.",
      };
    }
  }

  static async getPerson(rut) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/person/getByRut/${rut}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la persona.",
      };
    }
  }
  static async getInsurance(personId) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/oncologico/getInsuranceByPerson/${personId}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la insurance.",
      };
    }
  }
  static async checkHaveInsurance(rut) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/oncologico/checkHaveInsurance?rut=${rut}&sponsor=${VUE_APP_SPONSOR}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message || "Ocurrió un error al consultar.",
      };
    }
  }

  static async getInsuranceData(insuranceID) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/whatsapp/getInsuranceData/${insuranceID}`,
      );

      return shieldRes.data;
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrió un error al actualizar el contacto",
      };
    }
  }

  static async createLinkPayment(insuranceID) {
    const shieldRes = await axios.get(
      `${VUE_APP_SHIELD_URL}/whatsapp/generateLinkPayment/${insuranceID}`,
    );
    if (shieldRes.data.status === "ok") return shieldRes.data.data.link;
    else throw shieldRes.data;
  }

  static async getRecoverySellData(insuranceId) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/oncologico/getRecoverySellData/${insuranceId}`,
      );
      return response.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la insurance.",
      };
    }
  }

  static async generateRunWayPaymentRecovery(insuranceId) {
    try {
      const response = await axios.get(
        `${VUE_APP_SHIELD_URL}/oncologico/generateRunWayPaymentRecovery/${insuranceId}`,
      );
      return response;
    } catch (error) {
      return {
        data: {
          status: "error",
          message:
            error?.response?.data?.message ||
            "Ocurrió un error al consultar la insurance.",
        },
      };
    }
  }

  static async getRunWayPaymentData(transactionId) {
    try {
      const shieldRes = await axios.get(
        `${VUE_APP_SHIELD_URL}/runWayPayment/getTransaction/${transactionId}/${VUE_APP_SPONSOR}`,
      );

      const decrypted = decryptFromURL(shieldRes.data.data);

      const infoData = JSON.parse(decrypted);

      return shieldRes.data.status === "ok" ? infoData : [];
    } catch (error) {
      return {
        status: "error",
        message: "Ocurrio un error al obtener la información de la insurance",
      };
    }
  }

  static async generateBrevoClient(personBody, stage, token) {
    try {
      const shieldResponse = await axios.post(
        `${VUE_APP_SHIELD_URL}/brevo/recurseContact`,
        {
          flowData: {
            ...personBody,
          },
          sponsor: VUE_APP_SPONSOR,
          stage,
        },
        {
          headers: {
            "x-captcha-authorization": token,
          },
        },
      );
      return shieldResponse.data;
    } catch (error) {
      return {
        status: "error",
        message:
          error?.response?.data?.message ||
          "Ocurrió un error al consultar la lista negra.",
      };
    }
  }
}
